import React, { useContext } from 'react';
export const actionColumnDef = {
    width: 40
};
export const expandIconStyle = {
    width: 24
};
export const TableListContext = React.createContext({
    columnDefs: [],
    expandedRows: {},
    selectedRows: {},
    numRows: 0,
    numSelectedRows: 0,
    hPadding: 'm',
    onToggleAllSelection: (_selected)=>{},
    toggleExpandedRow: (state)=>state,
    setSelectedRows: (state)=>state,
    setSort: (state)=>state,
    expandAllRows: (_isAllExpanded)=>{},
    registerRow: (param)=>{
        let { rowId: _rowId, isExpanded: _isExpanded } = param;
    },
    unregisterRow: (_rowId)=>{}
});
export const useTableListContext = ()=>useContext(TableListContext);
